import { useRef, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { NumPad } from "@/components/NumPad";
import { BigButton } from "@/components/ui-kit";

// Runs fn directly for owner/manager; cashiers need a manager PIN.
export default function useManagerGate() {
  const { t, staff, view, verifyPin } = useApp();
  const pending = useRef(null);
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [err, setErr] = useState(false);
  const gate = (fn) => {
    if (["owner", "manager"].includes(staff?.role)) return fn();
    pending.current = fn;
    setPin(""); setErr(false); setOpen(true);
    return undefined;
  };
  const submit = async () => {
    for (const s of (view.staff || []).filter((x) => x.active && ["owner", "manager"].includes(x.role))) {
      if (await verifyPin(s, pin)) { setOpen(false); pending.current?.(); return; }
    }
    setErr(true); setPin("");
  };
  const dialog = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-xs" data-testid="manager-pin-dialog">
        <DialogTitle className="font-heading text-xl flex items-center gap-2"><ShieldCheck className="w-5 h-5" />{t("manager_pin")}</DialogTitle>
        <p className="text-sm text-muted-foreground">{t("manager_pin_hint")}</p>
        <div className="flex justify-center gap-3 my-1" dir="ltr">{[0, 1, 2, 3].map((i) => <span key={i} className={`w-4 h-4 rounded-full border-2 border-[#0B2A5B] ${pin.length > i ? "bg-[#0B2A5B]" : ""}`} />)}</div>
        {err && <p className="text-destructive font-bold text-sm text-center" data-testid="manager-pin-error">{t("wrong_pin")}</p>}
        <NumPad value={pin} onChange={(v) => setPin(v.slice(0, 4))} allowDot={false} testid="manager-pin-numpad" />
        <BigButton onClick={submit} disabled={pin.length < 4} className="w-full" data-testid="manager-pin-submit">OK</BigButton>
      </DialogContent>
    </Dialog>
  );
  return [gate, dialog];
}
